import { render, staticRenderFns } from "./WithdrawLimitation.vue?vue&type=template&id=e8f8767a&scoped=true&"
import script from "./WithdrawLimitation.vue?vue&type=script&lang=js&"
export * from "./WithdrawLimitation.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawLimitation.vue?vue&type=style&index=0&id=e8f8767a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f8767a",
  null
  
)

component.options.__file = "WithdrawLimitation.vue"
export default component.exports